import React from "react";
import NavbarTop from "../Components/NavbarTop";
import { ReactComponent as CheckedBig } from "../../assets/login/checked_big.svg";
// import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";
import { Link } from "react-router-dom";
import logo from "../../assets/logo/radis.png";
import MainButton from "../../commonComponents/MainButton";
import { useNavigate } from "react-router-dom";

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* <NavbarTop /> */}
      <div className="h-full flex items-center">
        <div className=" flex justify-center w-full top-[120px]">
          <div className="bg-white h-[580px] w-[960px] shadow-lg relative rounded-2xl flex justify-center">
            <div className="flex justify-center w-[400px] flex-col items-center">
              <CheckedBig className="w-[300px] h-[200px] mt-[-40px] mr-[30px]" />
              <h1 className=" text-3xl w-[500px] mt-[35px] text-center font-Poppins-SemiBold h-[50px]">Votre abonnement est confirmé.</h1>
              <p className=" text-lg w-[550px] mt-[20px] text-center font-Poppins-Light h-[50px]">
                Nous vous remercions pour votre confiance et restons à votre disposition pour vous accompagner lors de votre expérience.
              </p>

              <div className="flex items-center w-[200px] justify-center h-[40px] mt-[40px]">
                <MainButton disabled={true} callback={async () => navigate("/Profile")} title={"Revenir"} styleWind={"text-xs px-[10px]"} />
              </div>

              <p className="text-[#BEC4C] absolute bottom-2 text-xs font-Poppins-Light">Fait pour la planète par lokalité © - 2022</p>
            </div>
          </div>
          <img src={logo} alt="logo" className="absolute h-[320px] transparent left-[965px] top-[120px] opacity-30" />
        </div>
      </div>
    </>
  );
};

export default PaymentSuccessPage;
